import { render, staticRenderFns } from "./respuestas_foro.vue?vue&type=template&id=0b4755a4"
import script from "./respuestas_foro.vue?vue&type=script&lang=js"
export * from "./respuestas_foro.vue?vue&type=script&lang=js"
import style0 from "./respuestas_foro.vue?vue&type=style&index=0&id=0b4755a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports